import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { ContentSection } from "@/data/blogPosts"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function calculateReadingTime(content: ContentSection[]): number {
  const wordsPerMinute = 200;
  let wordCount = 0;
  
  content.forEach(section => {
    if (section.content) {
      wordCount += section.content.split(/\s+/).length;
    }
    if (section.items) {
      section.items.forEach(item => {
        wordCount += item.split(/\s+/).length;
      });
    }
  });
  
  return Math.max(1, Math.ceil(wordCount / wordsPerMinute));
}
